import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FaUpload } from "react-icons/fa";
import { addOrder, addCSV } from "../../Services/orderService";
import toast from "react-hot-toast";

const AddOrders = () => {

    const [formData, setFormData] = useState({
        customerName: "",
        phoneNumber: "",
        address: "",
        city: "",
        articleName: "",
        quantity: 1,
        amount: "",
        cnic: "",
        bookingAgent: "",
        remark: "",
        is_confirmed: "",
        product: ""
    });

    /* 🔹 INPUT CHANGE */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    /* 🔹 SUBMIT SINGLE ORDER */
    const handleSubmit = async (e) => {
        e.preventDefault();

        const res = await addOrder(formData);

        if (res?.status === "success") {
            toast.success("Order added successfully");

            setFormData({
                customerName: "",
                phoneNumber: "",
                address: "",
                city: "",
                articleName: "",
                quantity: 1,
                amount: "",
                cnic: "",
                bookingAgent: "",
                remark: "",
                is_confirmed: ""
            });
        } else {
            toast.error(res?.message || "Something went wrong");
        }
    };

    /* 🔹 CSV / EXCEL UPLOAD */
    const handleCSVUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        const res = await addCSV(formData);

        if (res?.status === "success") {
            toast.success("CSV uploaded successfully");
            e.target.value = ""; // reset input
        } else {
            toast.error(res?.message || "Upload failed");
        }
    };

    return (
        <div className="container">
            <div className="row mb-3">
                <div className="col">
                    <h4 className="fw-semibold">Add Orders</h4>
                </div>

                <div className="col-auto">
                    <Button variant="success" as="label">
                        <FaUpload size={16} className="me-2" />
                        Upload CSV
                        <input
                            type="file"
                            hidden
                            accept=".xlsx,.xls,.csv"
                            onChange={handleCSVUpload}
                        />
                    </Button>
                </div>
            </div>

            <Form className="row" onSubmit={handleSubmit}>
                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                        name="customerName"
                        value={formData.customerName}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Phone Number *</Form.Label>
                    <Form.Control
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Address *</Form.Label>
                    <Form.Control
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>City *</Form.Label>
                    <Form.Control
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Article Name *</Form.Label>
                    <Form.Control
                        name="articleName"
                        value={formData.articleName}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Product *</Form.Label>
                    <Form.Control
                        name="product"
                        value={formData.product}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Quantity *</Form.Label>
                    <Form.Control
                        type="number"
                        min="1"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Amount *</Form.Label>
                    <Form.Control
                        type="number"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>CNIC</Form.Label>
                    <Form.Control
                        name="cnic"
                        value={formData.cnic}
                        onChange={handleChange}
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Booking Agent</Form.Label>
                    <Form.Control
                        name="bookingAgent"
                        value={formData.bookingAgent}
                        onChange={handleChange}
                    />
                </Form.Group>

                <Form.Group className="col-lg-6 mb-3">
                    <Form.Label>Remark</Form.Label>
                    <Form.Control
                        name="remark"
                        value={formData.remark}
                        onChange={handleChange}
                    />
                </Form.Group>

                <div className="text-end">
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default AddOrders;
